<div class="flex items-center flex-wrap gap-10">
    <label *ngFor="let option of options" class="flex items-center gap-4 cursor-pointer select-none">
        <!-- Radio Circle -->
        <div class="w-6 h-6 rounded-full border flex items-center justify-center transition-colors duration-200"
            [ngClass]="{
            'border-(--text-placeholder)': selectedValue !== option.value,
            'border-(--brand-primary) border-6': selectedValue === option.value
        }" (click)="onSelect(option.value)">
        </div>

        <!-- Label -->
        <span class="text-medium" (click)="onSelect(option.value)">{{ option.label | translate }}</span>
    </label>
</div>